import React, { memo, useMemo } from 'react';

import TableDiv from 'components/shared/TableDiv';

import { useLayoutHeight } from '../../functions';
import OrdinaryPage from '../../Templates/OrdinaryPage';
import Page from '../Page';
import Blocks from '../Page/Blocks';
import { getColumns, getSeparateBlocks, useTripManifestPage } from './functions';
import s from './index.module.css';

function TripManifest({ onReady }) {
  const columns = useMemo(() => getColumns(), []);
  const {
    innerPages,
    ecBlocks,
    showCondition,
    tableSubtitle,
    ecSubtitle,
    handleFailureHandler,
    setECPageReady,
    handleReady,
  } = useTripManifestPage({
    onReady,
  });

  if (showCondition) {
    return null;
  }

  return (
    <>
      {innerPages.map((p, i) => (
        <MemoizedRecursiveManifestPage
          key={i}
          blocks={p}
          onFail={handleFailureHandler}
          onReady={handleReady}
          columns={columns}
          isLastPage={i === innerPages.length - 1}
          tableSubtitle={tableSubtitle}
          ecSubtitle={ecSubtitle}
        />
      ))}
      {ecBlocks && (
        <Page subtitle={ecSubtitle} blocks={ecBlocks} title="Trip Manifest" onReady={() => setECPageReady(true)} />
      )}
    </>
  );
}

export default TripManifest;

function RecursiveManifestPage({ blocks = [], columns, onReady, onFail, isLastPage, tableSubtitle }) {
  const spaceRef = useLayoutHeight({
    maxHeight: 790,
    ignore: !isLastPage,
    blocks,
    onReady,
    onFail: () => onFail(blocks),
  });
  const [, tableBlocks, emergencyContacts] = useMemo(() => getSeparateBlocks(blocks), [blocks]);
  const pageSubtitle = tableBlocks.length > 0 ? tableSubtitle : undefined;

  return (
    <OrdinaryPage title="Trip Manifest" subtitle={pageSubtitle}>
      <div ref={spaceRef}>
        {tableBlocks.length > 0 && (
          <TableDiv
            columns={columns}
            tableClassName={s.table}
            tableHeadClassName={s.tableHead}
            data={tableBlocks}
            disableSortBy
          />
        )}
        {emergencyContacts && <Blocks items={emergencyContacts} />}
      </div>
    </OrdinaryPage>
  );
}

const MemoizedRecursiveManifestPage = memo(
  RecursiveManifestPage,
  (prev, next) => prev.blocks.length === next.blocks.length,
);
